// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/UnileverShilling.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/UnileverDesire-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/UnileverDesire-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/UnileverDesire-RegularItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/UnileverDesire-Light.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Unilever Shilling";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Unilever Desire Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Unilever Desire Semi Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Unilever Desire Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Unilever Desire Regular Italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: 400;
  font-style: italic;
}
@font-face {
  font-family: "Unilever Desire Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff");
  font-weight: 300;
  font-style: normal;
}
* {
  margin: 0;
}

.Header_details__cRnhu {
  display: none;
  font-size: 14px;
  padding-top: 2px;
  padding-left: 350px;
}
.Header_details__cRnhu p {
  font-weight: 14px;
}
.Header_details__cRnhu p span {
  font-weight: 600;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_details__cRnhu {
    display: none;
    padding-left: 0px;
    flex-direction: column;
    align-items: end;
    text-align: end;
    padding-top: 30px;
    height: 0px;
  }
}

.Header_detailsRole__LZEwu {
  padding-right: 8px;
  border-right: 1px solid;
}
.Header_detailsRole__LZEwu b {
  padding-left: 6px;
  font-size: 14px;
  font-weight: 400;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_detailsRole__LZEwu {
    border: none;
    padding: 0;
  }
}

.Header_assignment__LqmpZ {
  padding-left: 8px;
}
.Header_assignment__LqmpZ span {
  padding-right: 6px;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_assignment__LqmpZ {
    display: flex;
    flex-direction: row;
  }
  .Header_assignment__LqmpZ span {
    padding-right: 0px;
  }
}

.Header_header__tYP3q {
  width: 100%;
  background: linear-gradient(328deg, #006FDE 48.33%, #06C 101.85%);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_header__tYP3q {
    margin-bottom: 20px;
  }
}

.Header_headertop__hB8Bp {
  height: 80px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: rgba(1, 1, 1, 0.1607843137);
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_headertop__hB8Bp {
    border-bottom: none;
    height: 0;
  }
}

.Header_dttReports__\\+TOAK {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #FFFFFF;
  margin-left: 48px;
}
.Header_dttReports__\\+TOAK .Header_backArrow__nAmBn {
  width: 12px;
  height: 12px;
}
.Header_dttReports__\\+TOAK .Header_ucubeAiFrame__x\\+BJJ {
  padding-left: 4px;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_dttReports__\\+TOAK {
    display: none;
  }
}

.Header_navlinks__c7dGu, .Header_menuSide__0brMa {
  display: none;
  flex-direction: row;
  align-items: center;
  color: #FFFFFF;
  gap: 16px;
  margin-right: 180px;
  cursor: pointer;
}
.Header_navlinks__c7dGu p, .Header_menuSide__0brMa p {
  font-size: 14px;
  font-weight: 400;
  margin-top: 12px !important;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_navlinks__c7dGu p, .Header_menuSide__0brMa p {
    margin-top: 0px !important;
  }
}
.Header_navlinks__c7dGu span, .Header_menuSide__0brMa span {
  margin-left: 16px;
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;
}
.Header_navlinks__c7dGu span p, .Header_menuSide__0brMa span p {
  font-weight: 400;
  font-size: 14px;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_navlinks__c7dGu, .Header_menuSide__0brMa {
    position: absolute;
    left: -200%;
  }
  .Header_navlinks__c7dGu p, .Header_menuSide__0brMa p {
    margin-top: 0 !important;
  }
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_menuSide__0brMa {
    position: fixed;
    left: 0;
    top: 150px;
    height: 100%;
    width: 100%;
    background-color: #FFFFFF;
    color: #000000;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    z-index: 999;
  }
}

.Header_headerbottom__-Miie, .Header_headerSidebar__6iv2y {
  width: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
  padding-right: 170px;
  background: linear-gradient(328deg, #006FDE 48.33%, #06C 101.85%);
}
.Header_headerbottom__-Miie p, .Header_headerSidebar__6iv2y p {
  margin-right: 10px;
  font-weight: 600;
  font-size: 14px;
  color: #FFFFFF;
  margin-bottom: 5px !important;
}
.Header_headerbottom__-Miie .Header_hamMenu__-mR5S, .Header_headerSidebar__6iv2y .Header_hamMenu__-mR5S {
  display: none;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_headerbottom__-Miie, .Header_headerSidebar__6iv2y {
    padding-right: 12px;
    padding-bottom: 0px;
  }
  .Header_headerbottom__-Miie .Header_hamMenu__-mR5S, .Header_headerSidebar__6iv2y .Header_hamMenu__-mR5S {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    position: absolute;
    top: 22px;
    left: 16px;
  }
  .Header_headerbottom__-Miie .Header_hamMenu__-mR5S div, .Header_headerSidebar__6iv2y .Header_hamMenu__-mR5S div {
    width: 20px;
    height: 2px;
    border-radius: 2px;
    background-color: #FFFFFF;
  }
  .Header_headerbottom__-Miie p, .Header_headerSidebar__6iv2y p {
    margin-right: 16px;
    font-size: 14px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_headerSidebar__6iv2y {
    position: relative;
    background: linear-gradient(328deg, #006FDE 48.33%, #06C 101.85%);
    display: flex;
    flex-direction: column;
    height: 170px;
    width: 100%;
    justify-content: space-around;
  }
  .Header_headerSidebar__6iv2y div,
  .Header_headerSidebar__6iv2y p {
    width: 100%;
    display: flex;
  }
  .Header_headerSidebar__6iv2y .Header_hamMenu__-mR5S {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    margin-left: 0;
    position: absolute;
    top: 22px;
    right: 22px;
    left: initial;
  }
  .Header_headerSidebar__6iv2y p {
    display: none;
  }
}

.Header_menuIcons__TtrFu {
  display: none;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_menuIcons__TtrFu {
    display: block;
  }
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_menuSide__0brMa {
    border-radius: 24px 24px 0px 0px;
    padding-top: 32px;
  }
  .Header_menuSide__0brMa div,
  .Header_menuSide__0brMa span {
    display: flex;
    flex-direction: row;
    gap: 16px;
    height: 64px;
    align-items: center;
    text-align: center;
    margin-left: 16px;
  }
}

.Header_logout__-Zr\\+t {
  margin-top: 10px;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_logout__-Zr\\+t {
    display: none;
  }
}

.Header_logout_blue__JTQxQ {
  display: none;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_logout_blue__JTQxQ {
    display: block;
  }
}

.Header_header1__Haqt7, .Header_noneHeader__d5-mI {
  background-color: rgba(0, 0, 0, 0.0784313725);
  height: 56px;
  font-size: 20px;
  color: #FFFFFF;
  font-weight: 900;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  padding: 0px 54px;
  border-bottom: 1px solid #3BADEB;
}
.Header_header1__Haqt7 > img, .Header_noneHeader__d5-mI > img {
  display: none;
}
.Header_header1__Haqt7 .Header_ucubeFieldForceLogo__9wKQL, .Header_noneHeader__d5-mI .Header_ucubeFieldForceLogo__9wKQL {
  display: block !important;
  margin: 0;
  width: auto;
  height: auto;
  padding: 18px 24px;
  align-self: center;
  color: #FFFFFF;
  font-family: "Unilever Desire Regular", sans-serif;
  font-size: 20px;
  font-style: normal;
  line-height: 20px;
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
}
@media only screen and (max-width: 1240px) {
  .Header_header1__Haqt7 .Header_ucubeFieldForceLogo__9wKQL, .Header_noneHeader__d5-mI .Header_ucubeFieldForceLogo__9wKQL {
    padding: 0;
  }
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_header1__Haqt7, .Header_noneHeader__d5-mI {
    gap: 8px;
    font-size: 16px;
    padding: 8px 16px;
    height: initial;
  }
  .Header_header1__Haqt7 > img, .Header_noneHeader__d5-mI > img {
    display: initial;
  }
  .Header_header1__Haqt7 .Header_ucubeFieldForceLogo__9wKQL, .Header_noneHeader__d5-mI .Header_ucubeFieldForceLogo__9wKQL {
    width: auto;
    height: auto;
    padding: 12px 16px;
    font-size: 16px;
    line-height: 16px;
    white-space: nowrap;
    overflow: visible;
    text-overflow: clip;
  }
}

.Header_header1Locate__F0CXq {
  height: 72px;
  border-bottom: 1px solid rgba(59, 173, 235, 0.3);
}

.Header_tabBarTabs__3IJNt {
  display: flex;
  align-items: flex-end;
  height: 100%;
  min-width: 0;
}

.Header_tabItem__tE3c0 {
  font-family: "Unilever Desire Semi Bold", sans-serif;
  display: inline-flex;
  align-items: center;
  padding: 18px 24px;
  border-radius: 8px;
  border-bottom: 1px solid transparent;
  cursor: pointer;
}
.Header_tabItem__tE3c0 p {
  margin: 0;
  font-family: "Unilever Desire Regular", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 120%;
  color: #FFFFFF;
  opacity: 0.9;
  white-space: nowrap;
}

.Header_tabItemActive__qRjNn {
  border-radius: 8px 8px 0 0;
  border-bottom: 2px solid #FFFFFF;
}
.Header_tabItemActive__qRjNn p {
  font-family: "Unilever Desire Semi Bold", sans-serif;
  font-size: 14px;
}

.Header_header1Right__vZcK2 {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1 1;
  height: 100%;
  min-width: 0;
}

.Header_header1RightLocate__EKX72 {
  align-items: flex-end;
  padding-bottom: 6px;
}

.Header_underLine__m7954 {
  text-decoration: underline;
}

.Header_bsaDropdown__7-p8x {
  border: none;
  background-color: #275CE6;
  color: #FFFFFF;
  overflow: hidden !important;
  outline: none;
  cursor: pointer;
}
.Header_bsaDropdown__7-p8x option {
  cursor: pointer;
}
.Header_bsaDropdown__7-p8x :focus {
  border: none;
}
.Header_bsaDropdown__7-p8x :focus-within {
  border: none;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_bsaDropdown__7-p8x {
    width: initial;
  }
  .Header_bsaDropdown__7-p8x option {
    min-width: 40px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_mobileViewAdjust__1bClJ {
    background-color: #275CE6;
    padding-bottom: 10px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_menuOpenView__aaTSt {
    background-color: #275CE6;
    padding-bottom: 10px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 99;
  }
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_noneHeader__d5-mI {
    position: absolute;
    top: 60px;
    left: 16px;
    z-index: 10;
  }
  .Header_noneHeader__d5-mI img {
    display: none;
  }
}

.Header_backArrow__nAmBn {
  width: 24px;
  height: 24px;
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_headerbottomMobile__eyV34 {
    width: 100%;
    background-color: #275CE6;
    min-height: 60px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_flexibleRow__6wG9y {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px 16px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_mobileCenterLogo__kdHTf {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 143px;
    height: 49px;
    cursor: pointer;
  }
}

:root {
  --rt-opacity: 1 !important;
}

.Header_country_popup__Eh-t2 {
  margin-right: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0;
}
.Header_country_popup__Eh-t2 .Header_countryName__QE-kZ {
  display: flex;
  align-items: center;
  padding-right: 0;
  gap: 8px;
}
.Header_country_popup__Eh-t2 .Header_countryName__QE-kZ .Header_name__q1P1l {
  font-size: 20px !important;
  font-weight: 400 !important;
  margin-bottom: 5px !important;
  color: #FFFFFF;
}
.Header_country_popup__Eh-t2 .Header_countryName__QE-kZ .Header_countryLogo__agyjj {
  border-radius: 50%;
}
.Header_country_popup__Eh-t2 .Header_profileIcon__xoq-b {
  cursor: pointer;
  display: flex;
  align-items: center;
  border-left: 1px solid #5588F7;
  padding-left: 20px;
  margin-left: 20px;
}
.Header_country_popup__Eh-t2 .Header_profileIcon__xoq-b img {
  width: 37px;
  height: 37px;
}
.Header_country_popup__Eh-t2 .Header_popupModal__x6DjT {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 0px !important;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  z-index: 1000;
  overflow: visible;
}
.Header_country_popup__Eh-t2 .Header_popupModal__x6DjT .Header_popup__XSnBD {
  width: 344px;
  display: flex;
  flex-direction: column;
  gap: 0px;
  cursor: auto !important;
}
.Header_country_popup__Eh-t2 .Header_popupModal__x6DjT .Header_popup__XSnBD .Header_popupDetails__CMyID {
  padding: 16px;
  width: 100%;
  border-radius: 0px;
  background: #C2E0FF;
  color: #000000;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}
.Header_country_popup__Eh-t2 .Header_popupModal__x6DjT .Header_popup__XSnBD .Header_popupDetails__CMyID .Header_popupProfileIcon__3g4Rc {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #FFFFFF;
  padding: 12px;
  box-sizing: border-box;
  object-fit: contain;
  object-position: center;
  flex-shrink: 0;
}
.Header_country_popup__Eh-t2 .Header_popupModal__x6DjT .Header_popup__XSnBD .Header_popupDetails__CMyID .Header_profileText__gO\\+3F {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
}
.Header_country_popup__Eh-t2 .Header_popupModal__x6DjT .Header_popup__XSnBD .Header_popupDetails__CMyID h4 {
  font-family: "Unilever Desire Bold", sans-serif;
  font-size: 16px;
  margin: 0;
  line-height: 120%;
  color: #000000;
}
.Header_country_popup__Eh-t2 .Header_popupModal__x6DjT .Header_popup__XSnBD .Header_popupDetails__CMyID p {
  font-family: "Unilever Desire Regular", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 120%;
  color: #000000;
  margin: 0;
}
.Header_country_popup__Eh-t2 .Header_popupModal__x6DjT .Header_popup__XSnBD .Header_userDetailsPopup__9vwH1 {
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #FFFFFF;
}
.Header_country_popup__Eh-t2 .Header_popupModal__x6DjT .Header_popup__XSnBD .Header_popup_role__b3VOi {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 8px;
  font-weight: 600;
  color: #000000;
}
.Header_country_popup__Eh-t2 .Header_popupModal__x6DjT .Header_popup__XSnBD .Header_popup_role__b3VOi .Header_popup_role_label__vyll4 {
  line-height: normal;
  color: #000000;
  font-family: "Unilever Desire Semi Bold", sans-serif;
  color: #333C43;
  font-size: 16px;
}
.Header_country_popup__Eh-t2 .Header_popupModal__x6DjT .Header_popup__XSnBD .Header_popup_role__b3VOi p {
  font-family: "Unilever Desire Regular", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #333C43;
  margin: 0;
}
.Header_country_popup__Eh-t2 .Header_popupModal__x6DjT .Header_popup__XSnBD .Header_popup_role__b3VOi .Header_popupDetails_bsaDropdown__QgE6v {
  display: flex;
  gap: 8px;
  border-bottom: 1px solid #A7B2C2;
  background-color: transparent;
  color: #000000;
}
.Header_country_popup__Eh-t2 .Header_popupModal__x6DjT .Header_popup__XSnBD .Header_popup_role_bsa__hcUgA {
  flex-direction: column;
  align-items: flex-start;
  gap: 0px;
}
.Header_country_popup__Eh-t2 .Header_popupModal__x6DjT .Header_popup__XSnBD .Header_popup_role_bsa__hcUgA .Header_popup_role_label__vyll4 {
  margin: 0;
}
.Header_country_popup__Eh-t2 .Header_popupModal__x6DjT .Header_popup__XSnBD .Header_popup_role_stack__IjPHV {
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.Header_country_popup__Eh-t2 .Header_popupModal__x6DjT .Header_popup__XSnBD .Header_popupLogout__-dgfm {
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 0px 16px 24px 16px;
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 0px;
  background: transparent;
  justify-content: flex-start;
  align-items: center;
  transition: background-color 0.3s ease;
}
.Header_country_popup__Eh-t2 .Header_popupModal__x6DjT .Header_popup__XSnBD .Header_popupLogout__-dgfm img {
  display: none;
}
.Header_country_popup__Eh-t2 .Header_popupModal__x6DjT .Header_popup__XSnBD .Header_popupLogout__-dgfm p {
  color: #0066CC;
  font-family: "Unilever Desire Semi Bold", sans-serif;
  font-weight: 600;
  font-size: 14px;
  padding-left: 0px;
  margin: 0;
}
.Header_country_popup__Eh-t2 .Header_separator__opSPz {
  width: 1px;
  height: 37px;
  background-color: #5588F7;
  margin: 0 20px;
  display: flex;
  align-self: center;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .Header_country_popup__Eh-t2 {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_mixin.scss","webpack://./src/components_upgrade/Header/Header.module.scss","webpack://./src/assets/styles/_variables.scss","webpack://./src/assets/styles/tokens/_spacing.scss","webpack://./src/assets/styles/tokens/_colors.scss","webpack://./src/assets/styles/tokens/_sizing.scss","webpack://./src/assets/styles/tokens/_typography.scss","webpack://./src/assets/styles/tokens/_radius.scss","webpack://./src/assets/styles/tokens/_shadows.scss"],"names":[],"mappings":"AAIA;EACE,gCAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;ACHF;ADMA;EACE,sCAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACJF;ADQA;EACE,wCAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACNF;ADUA;EACE,mCAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACRF;ADWA;EACE,6CAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACTF;ADYA;EACE,oCAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACVF;AAhCA;EACE,SAAA;AAkCF;;AA/BA;EACE,aAAA;EACA,eC+BkB;ED9BlB,gBEPa;EFQb,mBAAA;AAkCF;AAhCE;EACE,iBC0BgB;ADQpB;AAhCI;EACE,gBCoCiB;ADFvB;ADYE;ECxDF;IAeI,aAAA;IACA,iBCyCW;IDxCX,sBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBELU;IFMV,WCoCW;EDHb;AACF;;AA9BA;EACE,kBEhBa;EFiBb,uBAAA;AAiCF;AA/BE;EACE,iBAAA;EACA,eCEgB;EDDhB,gBCYiB;ADqBrB;ADTE;EC/BF;IAWI,YAAA;IACA,UAAA;EAiCF;AACF;;AA9BA;EACE,iBEhCa;AFiEf;AA/BE;EACE,kBAAA;AAiCJ;ADtBE;ECfF;IAQI,aAAA;IACA,mBAAA;EAiCF;EA/BE;IACE,kBCIS;ED6Bb;AACF;;AA7BA;EACE,WAAA;EACA,iEAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAgCF;ADvCE;ECEF;IAQI,mBEvDS;EFwFX;AACF;;AA9BA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,uCAAA;AAiCF;ADtDE;ECcF;IASI,mBAAA;IACA,SAAA;EAmCF;AACF;;AAhCA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cGzFY;EH0FZ,iBEtEc;AFyGhB;AAjCE;EACE,WAAA;EACA,YAAA;AAmCJ;AAhCE;EACE,iBAAA;AAkCJ;AD3EE;EC4BF;IAiBI,aAAA;EAkCF;AACF;;AA/BA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cG9GY;EH+GZ,SCjDW;EDkDX,mBAAA;EACA,eAAA;AAkCF;AAhCE;EACE,eClFgB;EDmFhB,gBCxEiB;EDyEjB,2BAAA;AAkCJ;AD/FE;EC0DA;IAMI,0BAAA;EAmCJ;AACF;AAhCE;EACE,iBChES;EDiET,aAAA;EACA,QErHW;EFsHX,mBAAA;EACA,eAAA;AAkCJ;AAhCI;EACE,gBCxFe;EDyFf,eCpGc;ADsIpB;AD/GE;ECiDF;IAiCI,kBAAA;IACA,WAAA;EAiCF;EA/BE;IACE,wBAAA;EAiCJ;AACF;;ADxHE;EC2FF;IAII,eAAA;IACA,OAAA;IACA,UAAA;IACA,YAAA;IACA,WAAA;IACA,yBG7JU;IH8JV,cG7JU;IH8JV,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,YAAA;EA8BF;AACF;;AA3BA;EACE,WAAA;EACA,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iEAAA;AA8BF;AA5BE;EACE,kBCpHS;EDqHT,gBCjImB;EDkInB,eC/IgB;EDgJhB,cGlLU;EHmLV,6BAAA;AA8BJ;AA3BE;EACE,aAAA;AA6BJ;AD3JE;EC6GF;IAqBI,mBC/HS;IDgIT,mBClIW;ED+Jb;EA3BE;IACE,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,QEzLQ;IF0LR,kBAAA;IACA,SAAA;IACA,UCxIO;EDqKX;EA1BE;IACE,WIlMS;IJmMT,WE9MS;IF+MT,kBE/MS;IFgNT,yBG7MQ;EHyOZ;EAzBE;IACE,kBCnJO;IDoJP,eChLc;ED2MlB;AACF;;ADrLE;EC8JF;IAII,kBAAA;IACA,iEAAA;IACA,aAAA;IACA,sBAAA;IACA,aAAA;IACA,WAAA;IACA,6BAAA;EAwBF;EAtBE;;IAEE,WAAA;IACA,aAAA;EAwBJ;EArBE;IACE,aAAA;IACA,yBAAA;IACA,qBAAA;IACA,cAAA;IACA,kBAAA;IACA,SAAA;IACA,WAAA;IACA,aAAA;EAuBJ;EApBE;IACE,aAAA;EAsBJ;AACF;;AAlBA;EACE,aAAA;AAqBF;ADvNE;ECiMF;IAII,cAAA;EAsBF;AACF;;AD5NE;ECyMF;IAEI,gCAAA;IACA,iBEpPU;EF0QZ;EApBE;;IAEE,aAAA;IACA,mBAAA;IACA,SC7MO;ID8MP,YAAA;IACA,mBAAA;IACA,kBAAA;IACA,iBCjNO;EDuOX;AACF;;AAlBA;EACE,gBC1NW;AD+Ob;ADjPE;EC2NF;IAII,aAAA;EAsBF;AACF;;AAnBA;EACE,aAAA;AAsBF;AD1PE;ECmOF;IAII,cAAA;EAuBF;AACF;;AApBA;EACE,6CGlR0B;EHmR1B,YAAA;EACA,eClQuB;EDmQvB,cGxSY;EHySZ,gBK9QkB;EL+QlB,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,iBAAA;EACA,gCAAA;AAuBF;AArBE;EACE,aAAA;AAuBJ;AApBE;EACE,yBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,cG5TU;EH6TV,kDKlUyB;ELmUzB,eCzRqB;ED0RrB,kBAAA;EACA,iBK/Sa;ELgTb,mBAAA;EACA,iBAAA;EACA,mBAAA;AAsBJ;AAnBE;EACE;IACE,UAAA;EAqBJ;AACF;ADrSE;EC2OF;IAyCI,QElUW;IFmUX,eC3SkB;ID4SlB,iBAAA;IACA,eAAA;EAqBF;EAnBE;IACE,gBAAA;EAqBJ;EAlBE;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,eCvTgB;IDwThB,iBC7RO;ID8RP,mBAAA;IACA,iBAAA;IACA,mBAAA;EAoBJ;AACF;;AAhBA;EACE,YAAA;EACA,gDAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;AAmBF;;AAhBA;EACE,oDKpX4B;ELqX5B,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,eAAA;AAmBF;AAjBE;EACE,SAAA;EACA,kDK/XyB;ELgYzB,eCzVgB;ED0VhB,gBC/UiB;EDgVjB,iBAAA;EACA,cC/XG;EDgYH,YAAA;EACA,mBAAA;AAmBJ;;AAfA;EACI,0BAAA;EACA,gCAAA;AAkBJ;AAhBE;EACE,oDK7Y0B;EL8Y1B,eCxWgB;AD0XpB;;AAdA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;AAiBF;;AAdA;EACE,qBAAA;EACA,mBAAA;AAiBF;;AAdA;EACE,0BAAA;AAiBF;;AAdA;EACE,YAAA;EACA,yBG7YmB;EH8YnB,cGnaY;EHoaZ,2BAAA;EACA,aAAA;EACA,eAAA;AAiBF;AAfE;EACE,eAAA;AAiBJ;AAdE;EACE,YAAA;AAgBJ;AAbE;EACE,YAAA;AAeJ;ADvYE;ECuWF;IAqBI,cAAA;EAeF;EAbE;IACE,eEraQ;EFobZ;AACF;;AD/YE;ECoYF;IAEI,yBG1aiB;IH2ajB,oBCrYS;EDmZX;AACF;;ADtZE;EC2YF;IAEI,yBGjbiB;IHkbjB,oBC5YS;ID6YT,eAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,WAAA;EAcF;AACF;;ADlaE;ECuZF;IAII,kBAAA;IACA,SE9bU;IF+bV,UCxZS;IDyZT,WAAA;EAYF;EAVE;IACE,aAAA;EAYJ;AACF;;AARA;EACE,WIvda;EJwdb,YIxda;AJmef;;ADnbE;EC2aF;IAEI,WAAA;IACA,yBGldiB;IHmdjB,gBEjdU;EF4dZ;AACF;;AD3bE;ECmbF;IAEI,kBAAA;IACA,WAAA;IACA,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,mBAAA;IACA,iBAAA;EAWF;AACF;;ADvcE;EC+bF;IAEI,kBAAA;IACA,SAAA;IACA,QAAA;IACA,gCAAA;IACA,YAAA;IACA,YAAA;IACA,eAAA;EAWF;AACF;;AARA;EACE,0BAAA;AAWF;;AARA;EACE,kBErfc;EFsfd,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,MAAA;AAWF;AATE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,QExgBW;AFmhBf;AATI;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,cGzhBQ;AHoiBd;AARI;EACE,kBM1hBU;ANoiBhB;AANE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,iBAAA;AAQJ;AALE;EACE,WIjiBW;EJkiBX,YIliBW;AJyiBf;AAJE;EACE,mBGhjBU;EHijBV,kBMpjBQ;ENqjBR,uBAAA;EACA,2COhjBW;EPijBX,aAAA;EACA,iBAAA;AAMJ;AAJI;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QCjgBS;EDkgBT,uBAAA;AAMN;AAJM;EACE,aCjgBK;EDkgBL,WAAA;EACA,kBCvgBO;EDwgBP,mBGjhBc;EHkhBd,cGlkBM;EHmkBN,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SCzgBK;AD+gBb;AAJQ;EACE,WEvjBI;EFwjBJ,YExjBI;EFyjBJ,kBMzkBM;EN0kBN,mBG7kBI;EH8kBJ,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAMV;AAHQ;EACE,aAAA;EACA,sBAAA;EACA,QE9kBI;EF+kBJ,SAAA;AAKV;AAFQ;EACE,+CKhmBgB;ELimBhB,eC3jBY;ED4jBZ,SAAA;EACA,iBAAA;EACA,cGhmBI;AHomBd;AADQ;EACE,kDK1mBmB;EL2mBnB,eCpkBU;EDqkBV,gBC1jBW;ED2jBX,iBAAA;EACA,cGxmBI;EHymBJ,SAAA;AAGV;AACM;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SCpjBK;EDqjBL,mBGnnBM;AHonBd;AAEM;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,QE/mBO;EFgnBP,gBC5kBe;ED6kBf,cG3nBM;AH2nBd;AAEQ;EACE,mBAAA;EACA,cG/nBI;EHgoBJ,oDKroBoB;ELsoBpB,cG1kBa;EH2kBb,eChmBY;ADgmBtB;AAGQ;EACE,kDK5oBmB;EL6oBnB,eCtmBU;EDumBV,gBAAA;EACA,cGllBa;EHmlBb,SAAA;AADV;AAIQ;EACE,aAAA;EACA,QEroBK;EFsoBL,gCAAA;EACA,6BAAA;EACA,cGlpBI;AHgpBd;AAMM;EACE,sBAAA;EACA,uBAAA;EAGA,QClmBO;AD4lBf;AAQQ;EACE,SAAA;AANV;AAUM;EACE,sBAAA;EACA,uBAAA;EACA,QE5pBM;AFopBd;AAWM;EACE,aAAA;EACA,mBAAA;EACA,QEjqBO;EFkqBP,2BAAA;EACA,eAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kBCtnBO;EDunBP,uBAAA;EACA,2BAAA;EACA,mBAAA;EACA,sCAAA;AATR;AAWQ;EACE,aAAA;AATV;AAYQ;EACE,cGvoBU;EHwoBV,oDKhsBoB;ELisBpB,gBC9oBa;ED+oBb,eC5pBU;ED6pBV,iBCroBK;EDsoBL,SAAA;AAVV;AAgBE;EACE,UAAA;EACA,YI9rBW;EJ+rBX,yBGnrBmB;EHorBnB,cAAA;EACA,aAAA;EACA,kBAAA;AAdJ;ADroBE;EC+cF;IAwMI,aAAA;EAdF;AACF","sourcesContent":["@import \"./variables\";\n\n// Font family\n\n@font-face {\n  font-family: \"Unilever Shilling\";\n  src: url(\"../fonts/UnileverShilling.ttf\")format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Unilever Desire Regular\";\n  src: url(\"../fonts/UnileverDesire-Regular.woff\") format(\"woff\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n@font-face {\n  font-family: \"Unilever Desire Semi Bold\";\n  src: url(\"../fonts/UnileverDesire-Bold.woff\") format(\"woff\");\n  font-weight: 600;\n  font-style: normal;\n}\n\n\n@font-face {\n  font-family: \"Unilever Desire Bold\";\n  src: url(\"../fonts/UnileverDesire-Bold.woff\") format(\"woff\");\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Unilever Desire Regular Italic\";\n  src: url(\"../fonts/UnileverDesire-RegularItalic.woff\") format(\"woff\");\n  font-weight: 400;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Unilever Desire Light\";\n  src: url(\"../fonts/UnileverDesire-Light.woff\") format(\"woff\");\n  font-weight: 300;\n  font-style: normal;\n}\n\n\n\n\n\n// Font families and font-weights\n\n@mixin volteMedium {\n  font-family: \"Unilever Shilling\", sans-serif;\n}\n\n@mixin volteSemibold {\n  font-family: \"Unilever Shilling\", sans-serif;\n}\n\n@mixin sm {\n  @media only screen and (min-width: 320px) and (max-width: 767px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media only screen and (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm-min {\n  @media only screen and (min-width: 992px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media only screen and (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl-min {\n  @media only screen and (min-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media only screen and (min-width: 1280px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media only screen and (min-width: 1440px) {\n    @content;\n  }\n}\n\n@mixin sm-tab {\n  @media only screen and (max-width: 767px) {\n    @content;\n  }\n}\n\n@mixin ipad {\n  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {\n    @content;\n  }\n}\n\n","@import \"../../assets/styles/abstracts/variables\";\n@import \"../../assets/styles/abstracts/mixins\";\n\n* {\n  margin: 0;\n}\n\n.details {\n  display: none;\n  font-size: $font-size-sm-base;\n  padding-top: $spacing-xxxs;\n  padding-left: 350px;\n\n  p {\n    font-weight: $font-size-sm-base;\n\n    span {\n      font-weight: $font-weight-semibold;\n    }\n  }\n\n  @include sm {\n    display: none;\n    padding-left: $spacing-zero;\n    flex-direction: column;\n    align-items: end;\n    text-align: end;\n    padding-top: $spacing-2xl;\n    height: $spacing-zero;\n  }\n}\n\n.detailsRole {\n  padding-right: $spacing-sm-s;\n  border-right: 1px solid;\n\n  b {\n    padding-left: 6px;\n    font-size: $font-size-sm-base;\n    font-weight: $font-weight-normal;\n  }\n\n  @include sm {\n    border: none;\n    padding: 0;\n  }\n}\n\n.assignment {\n  padding-left: $spacing-sm-s;\n\n  span {\n    padding-right: 6px;\n  }\n\n  @include sm {\n    display: flex;\n    flex-direction: row;\n\n    span {\n      padding-right: $spacing-zero;\n    }\n  }\n}\n\n.header {\n  width: 100%;\n  background: linear-gradient(328deg, $color-bg-gradient-start 48.33%, $color-bg-gradient-end 101.85%);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  @include sm {\n    margin-bottom: $spacing-lg;\n  }\n}\n\n.headertop {\n  height: 80px;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  background: #01010129;\n  @include sm {\n    border-bottom: none;\n    height: 0;\n  }\n}\n\n.dttReports {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: $color-white;\n  margin-left: $spacing-4xl-m;\n\n  .backArrow {\n    width: 12px;\n    height: 12px;\n  }\n\n  .ucubeAiFrame{\n    padding-left: 4px;\n  }\n\n  @include sm {\n    display: none;\n  }\n}\n\n.navlinks {\n  display: none;\n  flex-direction: row;\n  align-items: center;\n  color: $color-white;\n  gap: $spacing-md;\n  margin-right: 180px;\n  cursor: pointer;\n\n  p {\n    font-size: $font-size-sm-base;\n    font-weight: $font-weight-normal;\n    margin-top: $spacing-sm !important;\n\n    @include sm {\n      margin-top: $spacing-zero !important;\n    }\n  }\n\n  span {\n    margin-left: $spacing-md;\n    display: flex;\n    gap: $spacing-sm-s;\n    align-items: center;\n    cursor: pointer;\n\n    p {\n      font-weight: $font-weight-normal;\n      font-size: $font-size-sm-base;\n    }\n  }\n\n  @include sm {\n    position: absolute;\n    left: -200%;\n\n    p {\n      margin-top: 0 !important;\n    }\n  }\n}\n\n.menuSide {\n  @extend .navlinks;\n\n  @include sm {\n    position: fixed;\n    left: 0;\n    top: 150px;\n    height: 100%;\n    width: 100%;\n    background-color: $color-white;\n    color: $color-black;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    z-index: 999;\n  }\n}\n\n.headerbottom {\n  width: 100%;\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  padding-right: 170px;\n  background: linear-gradient(328deg, $color-bg-gradient-start 48.33%, $color-bg-gradient-end 101.85%);\n\n  p {\n    margin-right: $spacing-xs;\n    font-weight: $font-weight-semibold;\n    font-size: $font-size-sm-base;\n    color: $color-white;\n    margin-bottom: 5px !important;\n  }\n\n  .hamMenu {\n    display: none;\n  }\n\n  @include sm {\n    padding-right: $spacing-sm;\n    padding-bottom: $spacing-zero;\n\n    .hamMenu {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      gap: $spacing-xxs;\n      position: absolute;\n      top: 22px;\n      left: $spacing-md;\n    }\n\n    .hamMenu div {\n      width: $size-icon-sm;\n      height: $spacing-xxxs;\n      border-radius: $spacing-xxxs;\n      background-color: $color-white;\n    }\n\n    p {\n      margin-right: $spacing-md;\n      font-size: $font-size-sm-base;\n    }\n  }\n}\n\n.headerSidebar {\n  @extend .headerbottom;\n\n  @include sm {\n    position: relative;\n    background: linear-gradient(328deg, $color-bg-gradient-start 48.33%, $color-bg-gradient-end 101.85%);\n    display: flex;\n    flex-direction: column;\n    height: 170px;\n    width: 100%;\n    justify-content: space-around;\n\n    div,\n    p {\n      width: 100%;\n      display: flex;\n    }\n\n    .hamMenu {\n      display: flex;\n      justify-content: flex-end;\n      align-items: flex-end;\n      margin-left: 0;\n      position: absolute;\n      top: 22px;\n      right: 22px;\n      left: initial;\n    }\n\n    p {\n      display: none;\n    }\n  }\n}\n\n.menuIcons {\n  display: none;\n\n  @include sm {\n    display: block;\n  }\n}\n\n.menuSide {\n  @include sm {\n    border-radius: $radius-lg $radius-lg 0px 0px;\n    padding-top: $spacing-3xl;\n\n    div,\n    span {\n      display: flex;\n      flex-direction: row;\n      gap: $spacing-md;\n      height: 64px;\n      align-items: center;\n      text-align: center;\n      margin-left: $spacing-md;\n    }\n  }\n}\n\n.logout {\n  margin-top: $spacing-xs;\n\n  @include sm {\n    display: none;\n  }\n}\n\n.logout_blue {\n  display: none;\n\n  @include sm {\n    display: block;\n  }\n}\n\n.header1 {\n  background-color: $color-header-secondary-bg;\n  height: 56px;\n  font-size: $font-size-md-xtraLarge;\n  color: $color-white;\n  font-weight: $font-weight-black;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  padding: $spacing-zero $spacing-page-x;\n  border-bottom: 1px solid $color-grid-border-cyan;\n\n  > img {\n    display: none;\n  }\n\n  .ucubeFieldForceLogo {\n    display: block !important;\n    margin: 0;\n    width: auto;\n    height: auto;\n    padding: $spacing-md-m $spacing-xl;\n    align-self: center;\n    color: $color-white;\n    font-family: $font-family-desire-regular;\n    font-size: $font-size-md-xtraLarge;\n    font-style: normal;\n    line-height: $line-height-sm;\n    white-space: nowrap;\n    overflow: visible;\n    text-overflow: clip;\n  }\n\n  @media only screen and (max-width: 1240px) {\n    .ucubeFieldForceLogo {\n      padding: 0;\n    }\n  }\n\n  @include sm {\n    gap: $spacing-sm-s;\n    font-size: $font-size-md-medium;\n    padding: $spacing-sm-s $spacing-md;\n    height: initial;\n\n    > img {\n      display: initial;\n    }\n\n    .ucubeFieldForceLogo {\n      width: auto;\n      height: auto;\n      padding: $spacing-sm $spacing-md;\n      font-size: $font-size-md-medium;\n      line-height: $spacing-md;\n      white-space: nowrap;\n      overflow: visible;\n      text-overflow: clip;\n    }\n  }\n}\n\n.header1Locate {\n  height: 72px;\n  border-bottom: 1px solid rgba(59, 173, 235, 0.3);\n}\n\n.tabBarTabs {\n  display: flex;\n  align-items: flex-end;\n  height: 100%;\n  min-width: 0;\n}\n\n.tabItem {\n  font-family: $font-family-desire-semibold;\n  display: inline-flex;\n  align-items: center;\n  padding: $spacing-md-m $spacing-xl;\n  border-radius: 8px;\n  border-bottom: 1px solid transparent;\n  cursor: pointer;\n\n  p {\n    margin: 0;\n    font-family: $font-family-desire-regular;\n    font-size: $font-size-sm-base;\n    font-weight: $font-weight-normal;\n    line-height: 120%;\n    color: $white;\n    opacity: 0.9;\n    white-space: nowrap;\n  }\n}\n\n.tabItemActive {\n    border-radius: 8px 8px 0 0;\n    border-bottom: 2px solid $color-white;\n\n  p {\n    font-family: $font-family-desire-semibold;\n    font-size: $font-size-sm-base;\n  }\n}\n\n.header1Right {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex: 1;\n  height: 100%;\n  min-width: 0;\n}\n\n.header1RightLocate {\n  align-items: flex-end;\n  padding-bottom: 6px;\n}\n\n.underLine {\n  text-decoration: underline;\n}\n\n.bsaDropdown {\n  border: none;\n  background-color: $color-primary-blue;\n  color: $color-white;\n  overflow: hidden !important;\n  outline: none;\n  cursor: pointer;\n\n  option {\n    cursor: pointer;\n  }\n\n  :focus {\n    border: none;\n  }\n\n  :focus-within {\n    border: none;\n  }\n\n  @include sm {\n    width: initial;\n\n    option {\n      min-width: $spacing-4xl;\n    }\n  }\n}\n\n.mobileViewAdjust {\n  @include sm {\n    background-color: $color-primary-blue;\n    padding-bottom: $spacing-xs;\n  }\n}\n\n.menuOpenView {\n  @include sm {\n    background-color: $color-primary-blue;\n    padding-bottom: $spacing-xs;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    z-index: 99;\n  }\n}\n\n.noneHeader {\n  @extend .header1;\n\n  @include sm {\n    position: absolute;\n    top: $spacing-6xl;\n    left: $spacing-md;\n    z-index: 10;\n\n    img {\n      display: none;\n    }\n  }\n}\n\n.backArrow {\n  width: $size-icon-md;\n  height: $size-icon-md;\n}\n\n.headerbottomMobile {\n  @include sm {\n    width: 100%;\n    background-color: $color-primary-blue;\n    min-height: $spacing-6xl;\n  }\n}\n\n.flexibleRow {\n  @include sm {\n    position: relative;\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: $spacing-zero $spacing-md;\n  }\n}\n\n.mobileCenterLogo {\n  @include sm {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: 143px;\n    height: 49px;\n    cursor: pointer;\n  }\n}\n\n:root {\n  --rt-opacity: 1 !important;\n}\n\n.country_popup {\n  margin-right: $spacing-4xl-m;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0;\n\n  .countryName {\n    display: flex;\n    align-items: center;\n    padding-right: 0;\n    gap: $spacing-sm-s;\n\n    .name {\n      font-size: $font-size-md-xtraLarge !important;\n      font-weight: $font-weight-normal !important;\n      margin-bottom: 5px !important;\n      color: $color-white;\n    }\n\n    .countryLogo {\n      border-radius: $radius-circle;\n    }\n  }\n\n  .profileIcon {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    border-left: 1px solid $color-secondary-blue;\n    padding-left: 20px;\n    margin-left: 20px;\n  }\n\n  .profileIcon img {\n    width: $size-icon-lg;\n    height: $size-icon-lg;\n  }\n\n  .popupModal {\n    background: $color-white;\n    border-radius: $radius-md;\n    padding: $spacing-zero !important;\n    box-shadow: $shadow-popup;\n    z-index: 1000;\n    overflow: visible;\n\n    .popup {\n      width: 344px;\n      display: flex;\n      flex-direction: column;\n      gap: $spacing-zero;\n      cursor: auto !important;\n\n      .popupDetails {\n        padding: $spacing-md;\n        width: 100%;\n        border-radius: $spacing-zero;\n        background: $color-new-blue-pale;\n        color: $color-black;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: $spacing-md;\n\n        .popupProfileIcon {\n          width: $spacing-4xl;\n          height: $spacing-4xl;\n          border-radius: $radius-circle;\n          background: $color-white;\n          padding: 12px;\n          box-sizing: border-box;\n          object-fit: contain;\n          object-position: center;\n          flex-shrink: 0;\n        }\n\n        .profileText {\n          display: flex;\n          flex-direction: column;\n          gap: $spacing-xxs;\n          flex: 1;\n        }\n\n        h4 {\n          font-family: $font-family-desire-bold;\n          font-size: $font-size-md-medium;\n          margin: 0;\n          line-height: 120%;\n          color: $color-black;\n        }\n\n        p {\n          font-family: $font-family-desire-regular;\n          font-size: $font-size-sm-base;\n          font-weight: $font-weight-normal;\n          line-height: 120%;\n          color: $color-black;\n          margin: 0;\n        }\n      }\n\n      .userDetailsPopup {\n        padding: $spacing-xl $spacing-md;\n        display: flex;\n        flex-direction: column;\n        gap: $spacing-md;\n        background: $color-white;\n      }\n\n      .popup_role {\n        display: flex;\n        flex-direction: row;\n        align-items: baseline;\n        gap: $spacing-sm-s;\n        font-weight: $font-weight-semibold;\n        color: $color-black;\n\n        .popup_role_label {\n          line-height: normal;\n          color: $color-black;\n          font-family: $font-family-desire-semibold;\n          color: $color-text-dark-grey;\n          font-size: $font-size-md-medium;\n        }\n\n        p {\n          font-family: $font-family-desire-regular;\n          font-size: $font-size-sm-base;\n          font-weight: 400;\n          color: $color-text-dark-grey;\n          margin: 0;\n        }\n\n        .popupDetails_bsaDropdown {\n          display: flex;\n          gap: $spacing-sm-s;\n          border-bottom: 1px solid $color-border-muted-blue;\n          background-color: transparent;\n          color: $color-black;\n        }\n      }\n\n      .popup_role_bsa {\n        flex-direction: column;\n        align-items: flex-start;\n\n        \n        gap: $spacing-zero;\n\n        .popup_role_label {\n          margin: 0;\n        }\n      }\n\n      .popup_role_stack {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: $spacing-xxs;\n      }\n\n      .popupLogout {\n        display: flex;\n        flex-direction: row;\n        gap: $spacing-sm-s;\n        padding: $spacing-zero $spacing-md $spacing-xl $spacing-md;\n        cursor: pointer;\n        width: fit-content;\n        border-radius: $spacing-zero;\n        background: transparent;\n        justify-content: flex-start;\n        align-items: center;\n        transition: background-color 0.3s ease;\n\n        img {\n          display: none;\n        }\n\n        p {\n          color: $color-button-blue;\n          font-family: $font-family-desire-semibold;\n          font-weight: $font-weight-semibold;\n          font-size: $font-size-sm-base;\n          padding-left: $spacing-zero;\n          margin: 0;\n        }\n      }\n    }\n  }\n\n  .separator {\n    width: 1px;\n    height: $size-icon-lg;\n    background-color: $color-secondary-blue;\n    margin: 0 20px;\n    display: flex;\n    align-self: center;\n  }\n\n  @include sm {\n    display: none;\n  }\n}\n\n","// Color codes here.\n$headerBlue:#275CE6;\n$headerBorder:#5588F7;\n$primaryBlue:#275CE6;\n$secondryBlue:#5588F7;\n$white:#FFFFFF;\n$tertiaryGrey:#676E72;\n$errorRed: #D52F3D;\n$progressRed:#E43263;\n$errorRed: #D52F3D;\n$progressGreen:#59B876;\n$progressCircleGrey:#9496A0;\n$black:#000000;\n$timedetailsGrey:#F3F7FD;\n$buttonbgBlue:#5588F7;\n$inputBorder:#CCCFD0;\n$buttonDisableBg:#E5E6E7;\n$buttonDisableText:#999EA1;\n$errorMessageRed:#FF5C83;\n$darkGreyText:#333C43;\n$tableHeader:#F6FCFF;\n$LandingPageBlue:#1E49B9;\n$secondary_lightish:#E1ECF5;\n$opTabViewDisabled:#F2F3F3;\n$otpGreyText:#B3B6C5;\n$otpErrorRed:#D52F3D;\n$oddTableRow: #f8f9fc;\n$agTableRow: #f3f3f3;\n$scrollbar: #888;\n$scrollbarHover: #555;\n$scrollbarTrack: #f1f1f1;\n$dropdownListColor: #f0f0f0;\n$dropdownShadow: #6123E70F;\n$disableButton : #cccccc;\n$progressContainer: #e0e0e0;\n$toggleSwitchOff: #00000066;\n$toggleSwitchOn: #03A742;\n// Font Sizes\n$font-size-xs-small: 10px;\n$font-size-sm-small: 12px;\n$font-size-sm-base: 14px;\n$font-size-md-medium: 16px;\n$font-size-md-large: 18px;\n$font-size-md-xtraLarge: 20px;\n$font-size-md-xLarge: 22px;\n$font-size-lg-medium: 24px;\n$font-size-xl-large: 32px;\n$font-size-xl-xtraLarge: 40px;\n$font-size-xl-medium: 28px;\n\n// Font weights\n$font-weight-normal: 400;\n$font-weight-medium: 500;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n// Font Styles\n$font-style: 'Unilever Shilling';\n$font-family-desire-light: 'Unilever Desire Light', sans-serif;\n\n// Line Height\n$line-height-medium: 16px;\n\n// Spacing\n$spacing-zero: 0px;\n$spacing-xs: 10px;\n$spacing-sm: 12px;\n$spacing-sm-m: 14px;\n$spacing-md: 16px;\n$spacing-md-m: 18px;\n","// Existing scale (preserved)\n$spacing-zero: 0px;\n$spacing-neg-xxxs: -3px;\n$spacing-xxxs: 2px;\n$spacing-xxxs-m: 3px;\n$spacing-xs-m: 5px;\n$spacing-xxs-m: 6px;\n$spacing-xs: 10px;\n$spacing-sm: 12px;\n$spacing-sm-m: 14px;\n$spacing-sm-l: 15px;\n$spacing-md: 16px;\n$spacing-md-s: 13px;\n$spacing-md-m: 18px;\n\n// New additions for landing components\n$spacing-xxs: 4px;\n$spacing-sm-s: 8px;\n$spacing-lg: 20px;\n$spacing-xl: 24px;\n$spacing-xl-s: 25px;\n$spacing-xl-m: 28px;\n$spacing-2xl: 30px;\n$spacing-3xl: 32px;\n$spacing-3xl-m: 36px;\n$spacing-4xl: 40px;\n$spacing-4xl-m: 48px;\n$spacing-5xl-s: 50px;\n$spacing-5xl: 56px;\n$spacing-6xl: 60px;\n$spacing-16xl: 160px;\n$spacing-page-content-x: 140px;\n$spacing-page-x: 54px;\n","//legend color boxes\n$color-perfectstore-orange: #FF9A00;\n$color-perfectstore-green: #52D273;\n$color-perfectstore-bar-bg: rgba(1, 45, 87, 1);\n$color-perfectstore-bar-gradient: linear-gradient(135deg,#1b5fa7,#0e4c8f);\n// --- Base ---\n$color-white: #FFFFFF;\n$color-black: #000000;\n\n// --- Brand Blues (Landing cards & panels) ---\n$color-card-bg-dark: #00000033;\n$color-card-bg-medium: #0D4F8E;\n$color-card-content: #0066CC;\n$color-card-image-bg: #005AB3;\n$color-panel-bg: #19326833;\n\n$color-card-bg-active: #042E55;\n$color-card-bg-hover: #1a3d7a;\n\n// --- Text on dark backgrounds ---\n$color-text-white-muted: rgba(255, 255, 255, 0.7);\n$color-overlay-white-70: rgba(255, 255, 255, 0.7);\n\n// --- Header & Navigation ---\n$color-header-bg: #01010129; \n$color-header-secondary-bg: #00000014; \n$color-header-primary-bg: #005AB4;\n$color-primary-blue: #275CE6;\n$color-secondary-blue: #5588F7;\n$color-border-blue: #2381DE;\n\n// --- Menu ---\n$color-menu-bg: #082D54;\n$color-menu-hover: #054179;\n\n// --- Neutral / UI ---\n$color-light-bg: #F3F7FD;\n\n// --- Notification ---\n$color-notification-bg: rgba(251, 245, 206, 0.95);\n$color-notification-border: #d2bf47;\n\n// --- Background Gradient ---\n$color-bg-gradient-start: #006FDE;\n$color-bg-gradient-end: #06C;\n$color-bg-gradient-card-blue: linear-gradient(0deg, #0D4F8E 0%, #0D4F8E 100%), #06C;\n$color-bg-gradient-secondary-start: #026CCE;\n$color-bg-gradient-secondary-end: #013768;\n\n// --- Blur Effects ---\n$color-blur-purple: rgba(120, 50, 180, 0.5);\n\n// --- Borders ---\n$color-border-white-translucent: rgba(255, 255, 255, 0.3);\n$color-border-light-blue: #C2E0FF;\n$color-new-blue-pale: #C2E0FF;\n\n// --- Buttons ---\n$color-button-blue: #0066CC;\n$color-login-primary-blue: #1E49B9;\n\n// --- Text ---\n$color-text-dark-grey: #333C43;\n\n// --- KPI / Status ---\n$color-kpi-green: #59B876;\n$color-kpi-red: #E43263;\n$color-kpi-error: #D52F3D;\n$color-text-light: #F2F3F3;\n$color-border-light: #f2f3f3;\n\n// --- KPI / Surfaces ---\n$color-kpi-header-bg: #1464B1;\n$color-kpi-body-bg: #044888;\n$color-kpi-badge-bg: #002B55;\n$color-kpi-switch-bg: #0F569B;\n$color-kpi-switch-active-bg: #004C99;\n$color-kpi-switch-selected-bg: #B9D8F8;\n$color-kpi-switch-selected-text: #0C3F70;\n$color-kpi-icon-bg: #DCEAFF;\n\n// --- Overlays / Borders ---\n$color-overlay-white-06: rgba(255, 255, 255, 0.06);\n$color-overlay-white-08: rgba(255, 255, 255, 0.08);\n$color-overlay-white-10: rgba(255, 255, 255, 0.1);\n$color-overlay-white-12: rgba(255, 255, 255, 0.12);\n$color-overlay-white-15: rgba(255, 255, 255, 0.15);\n$color-overlay-white-16: rgba(255, 255, 255, 0.16);\n$color-overlay-white-18: rgba(255, 255, 255, 0.18);\n$color-overlay-white-20: rgba(255, 255, 255, 0.2);\n$color-overlay-white-22: rgba(255, 255, 255, 0.22);\n$color-overlay-white-30: rgba(255, 255, 255, 0.3);\n$color-overlay-black-04: rgba(0, 0, 0, 0.04);\n$color-overlay-black-08: rgba(0, 0, 0, 0.08);\n$color-overlay-black-10: rgba(0, 0, 0, 0.1);\n$color-overlay-black-15: rgba(0, 0, 0, 0.15);\n$color-overlay-black-20: rgba(0, 0, 0, 0.2);\n$color-overlay-black-24: #0000003D;\n$color-overlay-black-30: rgba(0, 0, 0, 0.3);\n$color-overlay-black-38: rgba(0, 0, 0, 0.38);\n$color-overlay-modal-20: rgba(3, 13, 20, 0.2);\n$color-overlay-modal-12: rgba(3, 13, 20, 0.12);\n$color-overlay-panel-80: rgba(19, 48, 98, 0.8);\n$color-tab-active-overlay: rgba(15, 86, 155, 0.53);\n$color-border-neutral-10: #E5E6E7;\n$color-text-ivory: #F6F7F0;\n$color-border-white-soft: rgba(247, 247, 247, 0.32);\n$color-kpi-orange: #F5A623;\n$color-text-dark-primary: #111111;\n$color-kpi-card-top-bg: #1165B8;\n$color-progress-fill-blue: #8ADAFF;\n\n// --- Text / Neutral additions ---\n$color-text-muted-blue: #B8C7E0;\n$color-text-muted-blue-light: #DFE6F3;\n$color-text-slate-700: #1F2937;\n$color-text-disabled: #CCCCCC;\n$color-input-border: #CCCFD0;\n$color-text-neutral-40: #9496A0;\n$color-text-ic-01: #FFF0EF;\n$color-primary-darkest: #090041;\n\n// --- UI surface additions ---\n$color-overlay-white-04: rgba(255, 255, 255, 0.04);\n$color-overlay-white-10: rgba(255, 255, 255, 0.1);\n$color-overlay-white-52: rgba(255, 255, 255, 0.52);\n$color-overlay-white-55: rgba(255, 255, 255, 0.55);\n$color-overlay-white-72: rgba(255, 255, 255, 0.72);\n$color-border-soft-blue: #D5DBE5;\n$color-surface-hover-blue-soft: #EAF4FF;\n$color-border-muted-blue: #A7B2C2;\n$color-panel-blue: #265B9C;\n$color-overlay-black-80: rgba(0, 0, 0, 0.8);\n$color-error-border-pink: #FF5C83;\n\n// --- Grid additions ---\n$color-grid-header-overlay: rgba(19, 80, 153, 0.6);\n$color-grid-row-overlay: rgba(34, 88, 166, 0.45);\n$color-grid-border-cyan: #3BADEB;\n$color-grid-scroll-track: #133A76;\n$color-grid-scroll-thumb: #D9D9D9;\n$color-grid-scroll-thumb-hover: #BFBFBF;\n\n// --- KPI card additions ---\n$color-kpi-card-top-overlay: #0000002E;\n$color-kpi-card-bottom-overlay: #0000001A;\n$color-kpi-card-split-overlay: #082D5480;\n$color-kpi-card-summary-top: #0066CC33;\n$color-kpi-card-summary-body: #082D5433;\n$color-kpi-card-summary-cell: #044E9833;\n$color-kpi-positive-dot: #00D492;\n$color-kpi-negative-dot: #FF9AAB;\n\n// --- Status dot additions ---\n$color-status-dot-green: #03A742;\n$color-status-dot-red: #CA6580;\n\n// --- PS Filter Modal ---\n$color-filter-modal-overlay: rgba(0, 0, 0, 0.55);\n$color-filter-text-dark: #1a1a1a;\n$color-filter-border-inactive: #adb5c7;\n$color-filter-checkbox-active: #1565c0;\n$color-filter-checkbox-active-hover: #0d47a1;\n$color-filter-btn-disabled-bg: #d0d5df;\n$color-filter-btn-disabled-text: #8a8fa3;\n$color-filter-modal-shadow: rgba(0, 0, 0, 0.18);\n// --- SmTracking ---\n$color-smtracking-filter-badge: #D92D53;\n$color-new-blue-pale-50: rgba(194, 224, 255, 0.5);\n","//width \n\n$size-perfectstore-width: 1332px;\n$size-perfectstore-card-width: 432px;\n$size-perfectstore-card-height: 155px;\n$size-store-icon: 14px;\n$size-colored-box-width: 18px;\n$size-colored-box-height: 16px;\n$size-icon-xxs: 11px;\n$size-blur-lg: 400px;\n$size-blur-sm: 250px;\n\n// Icon sizes\n$size-icon-xs: 16px;\n$size-icon-sm: 20px;\n$size-icon-md: 24px;\n$size-icon-lg: 37px;\n\n// Dropdown sizes\n$size-dropdown-country-width: 219px;\n$size-dropdown-country-height: 229px;\n","$font-family-base: 'Unilever Desire', sans-serif;\n$font-family-desire-regular: 'Unilever Desire Regular', sans-serif;\n$font-family-desire-semibold: 'Unilever Desire Semi Bold', sans-serif;\n$font-family-desire-bold: 'Unilever Desire Bold', sans-serif;\n$font-family-desire-regular-italic: 'Unilever Desire Regular Italic', sans-serif;\n$font-family-desire-light: 'Unilever Desire Light', sans-serif;\n\n// Font sizes\n$font-size-xs-small: 10px;\n$font-size-sm-small: 12px;\n$font-size-sm-caption: 13px;\n$font-size-sm-base: 14px;\n$font-size-md-medium: 16px;\n$font-size-md-large: 18px;\n$font-size-md-xtraLarge: 20px;\n$font-size-md-xLarge: 22px;\n$font-size-lg-medium: 24px;\n$font-size-lg-large: 28px;\n$font-size-lg-xxlarge: 30px;\n$font-size-lg-xtraLarge: 32px;\n$font-size-xl-display: 42px;\n\n// Line heights\n$line-height-sm: 20px;\n$line-height-md: 24px;\n$line-height-lg: 32px;\n\n// Font weights\n$font-weight-light: 200;\n$font-weight-normal: 400;\n$font-weight-medium: 500;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n$font-weight-black: 900;\n","\n$radius-xs: 1px;\n$radius-sm: 4px;\n$radius-md: 8px;\n$radius-dropdown-country: 9px 8px 0 0;\n$radius-xl: 16px;\n$radius-lg: 24px;\n$radius-full: 40px;\n$radius-pill: 50px;\n$radius-circle: 50%;\n","// Card shadows\n$shadow-card-default: 0px 2px 20px rgba(0, 0, 0, 0.05);\n$shadow-card-hover: 0px 4px 28px rgba(0, 0, 0, 0.15);\n\n// Panel shadows\n$shadow-panel-default: 0px 0px 2px rgba(0, 0, 0, 0.04), 0px 4px 16px rgba(0, 0, 0, 0.05);\n$shadow-panel-hover: 0px 2px 24px rgba(0, 0, 0, 0.15);\n\n// Popup shadows\n$shadow-popup: 0 4px 4px 0 rgba(0, 0, 0, 0.25);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"details": `Header_details__cRnhu`,
	"detailsRole": `Header_detailsRole__LZEwu`,
	"assignment": `Header_assignment__LqmpZ`,
	"header": `Header_header__tYP3q`,
	"headertop": `Header_headertop__hB8Bp`,
	"dttReports": `Header_dttReports__+TOAK`,
	"backArrow": `Header_backArrow__nAmBn`,
	"ucubeAiFrame": `Header_ucubeAiFrame__x+BJJ`,
	"navlinks": `Header_navlinks__c7dGu`,
	"menuSide": `Header_menuSide__0brMa`,
	"headerbottom": `Header_headerbottom__-Miie`,
	"headerSidebar": `Header_headerSidebar__6iv2y`,
	"hamMenu": `Header_hamMenu__-mR5S`,
	"menuIcons": `Header_menuIcons__TtrFu`,
	"logout": `Header_logout__-Zr+t`,
	"logout_blue": `Header_logout_blue__JTQxQ`,
	"header1": `Header_header1__Haqt7`,
	"noneHeader": `Header_noneHeader__d5-mI`,
	"ucubeFieldForceLogo": `Header_ucubeFieldForceLogo__9wKQL`,
	"header1Locate": `Header_header1Locate__F0CXq`,
	"tabBarTabs": `Header_tabBarTabs__3IJNt`,
	"tabItem": `Header_tabItem__tE3c0`,
	"tabItemActive": `Header_tabItemActive__qRjNn`,
	"header1Right": `Header_header1Right__vZcK2`,
	"header1RightLocate": `Header_header1RightLocate__EKX72`,
	"underLine": `Header_underLine__m7954`,
	"bsaDropdown": `Header_bsaDropdown__7-p8x`,
	"mobileViewAdjust": `Header_mobileViewAdjust__1bClJ`,
	"menuOpenView": `Header_menuOpenView__aaTSt`,
	"headerbottomMobile": `Header_headerbottomMobile__eyV34`,
	"flexibleRow": `Header_flexibleRow__6wG9y`,
	"mobileCenterLogo": `Header_mobileCenterLogo__kdHTf`,
	"country_popup": `Header_country_popup__Eh-t2`,
	"countryName": `Header_countryName__QE-kZ`,
	"name": `Header_name__q1P1l`,
	"countryLogo": `Header_countryLogo__agyjj`,
	"profileIcon": `Header_profileIcon__xoq-b`,
	"popupModal": `Header_popupModal__x6DjT`,
	"popup": `Header_popup__XSnBD`,
	"popupDetails": `Header_popupDetails__CMyID`,
	"popupProfileIcon": `Header_popupProfileIcon__3g4Rc`,
	"profileText": `Header_profileText__gO+3F`,
	"userDetailsPopup": `Header_userDetailsPopup__9vwH1`,
	"popup_role": `Header_popup_role__b3VOi`,
	"popup_role_label": `Header_popup_role_label__vyll4`,
	"popupDetails_bsaDropdown": `Header_popupDetails_bsaDropdown__QgE6v`,
	"popup_role_bsa": `Header_popup_role_bsa__hcUgA`,
	"popup_role_stack": `Header_popup_role_stack__IjPHV`,
	"popupLogout": `Header_popupLogout__-dgfm`,
	"separator": `Header_separator__opSPz`
};
export default ___CSS_LOADER_EXPORT___;
